export default __webpack_public_path__ + "static/42-fit-8e25f2e75980540e26420564d6cd69e1.png";